import {
  ADMIN_AGENT_PANEL_DEFAULT_WIDTH,
  ADMIN_AGENT_PANEL_DESKTOP_BREAKPOINT,
  ADMIN_AGENT_PANEL_MAX_WIDTH,
  ADMIN_AGENT_PANEL_MIN_WIDTH,
  ADMIN_AGENT_PANEL_REMAINING_WORKSPACE_WIDTH,
} from "./admin-agent.constants";

export const getAdminAgentPanelMaximumWidth = (viewportWidth: number): number =>
  viewportWidth < ADMIN_AGENT_PANEL_DESKTOP_BREAKPOINT
    ? viewportWidth
    : Math.min(ADMIN_AGENT_PANEL_MAX_WIDTH, viewportWidth - ADMIN_AGENT_PANEL_REMAINING_WORKSPACE_WIDTH);

// Clamp the displayed size without replacing a saved desktop preference when the browser becomes narrow.
export const clampAdminAgentPanelWidth = (value: unknown, viewportWidth: number): number => {
  const width = typeof value === "number" && Number.isFinite(value) ? value : ADMIN_AGENT_PANEL_DEFAULT_WIDTH;
  const minimum = Math.min(ADMIN_AGENT_PANEL_MIN_WIDTH, viewportWidth);

  return Math.round(Math.max(minimum, Math.min(width, getAdminAgentPanelMaximumWidth(viewportWidth))));
};
